import { useTrack } from '../useTrack';
import type { EventProps } from './eventProps.types';
import { getLogger } from '../../libs/logger';

const logger = getLogger('CallEventTracking');

export const useTrackCallEvent = (): ((...args: EventProps) => void) => {
  const track = useTrack();

  return (eventName, data, altSegmentData?) => {
    // DataDog
    logger.info(eventName, data);

    // Analytics (Segment)
    void track(eventName, altSegmentData ?? data);
  };
};
